module.exports = __webpack_public_path__ + "static/media/contact-small-banner.4dd7d33f.svg";